import script from "./SideDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./SideDrawer.vue?vue&type=script&setup=true&lang=js"

import "./SideDrawer.vue?vue&type=style&index=0&id=208e4812&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-208e4812"]])

export default __exports__